module.exports = __webpack_public_path__ + "static/JG3-f4744cd2c2d41073c7091745e7ee4983.png";